module.exports = __webpack_public_path__ + "img/download_bg.e9bf244e.png";